import React, { Component, Fragment } from "react";
import { Link } from 'react-router-dom';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import PageHelmet from "../component/common/Helmet";
import Footer from "../component/footer/Footer";
import GoldAPI from "../blocks/GoldAPI";
import ProductMenu from "../elements/product/ProductMenu";

const ProductList1_image = <img src="/assets/images/home/product-list-01.webp" alt="ทองคำ 96.5%" />;
const ProductList2_image = <img src="/assets/images/home/product-list-02.webp" alt="ทองคำ 99%" />;
const ProductList3_image = <img src="/assets/images/home/product-list-03.webp" alt="ออมทอง" />;

const ProductList = [
    {
        image: ProductList1_image,
        link: '/gold965',
        title: 'ซื้อ-ขาย ทองคำ',
        titleTwo: 'ทองคำความบริสุทธิ์ 96.5%',
        titleBtn: 'อ่านรายละเอียด'
    },
    {
        image: ProductList2_image,
        link: '/gold99',
        title: 'ซื้อ-ขาย ทองคำ',
        titleTwo: 'ทองคำความบริสุทธิ์ 99.99% LBMA',
        titleBtn: 'อ่านรายละเอียด'
    },
    {
        image: ProductList3_image,
        link: '/goldsaver',
        title: 'ออมทอง',
        titleTwo: 'ออมแบบไม่ล็อคราคา',
        titleBtn: 'อ่านรายละเอียด'
    }
]



class Startup extends Component {
    static defaultProps = {
        center: {
            lat: 59.95,
            lng: 30.33
        },
        zoom: 11
    };
    render() {
        return (
            <Fragment>
                <PageHelmet pageTitle='ห้างทองเยาวราช 1 ยโสธร' />
                <div className="text-white">
                    <Header logoname="logo.webp" />
                </div>

                <section data-headercolordesktop="white" data-headercolortablet="white" data-headercolormobile="white" class="section hero-section">
                    <div class="gtmBlock" id="gtm-block-1" data-v-c0126ca2="">
                        <div href="">
                            <div class="hero -full">
                                <video class="image" src="/assets/video/bgvideo.mp4" loop="1" autoplay="1" muted="1" playsinline="" poster="/assets/images/bg/bg-image-1.webp"></video>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Start API Graph */}
                <div className="api-graph-area bg_color--2 ptb--30">
                    <GoldAPI />
                </div >
                {/* End API Graph */}


                <div className="video-highlight">
                    <div className="section-title mt--30 ptb--30">
                        <h1>แนะนำคอลเลคชั่นพิเศษ</h1>
                    </div>
                    <div className="row text-center">
                        <div className="col-12">
                            <video class="image" src="/assets/video/Yaowarat-Set1.mp4" loop="1" autoplay="1" muted="1" playsinline="" poster="/assets/video/poster/Yaowarat-Set1.webp"></video>
                            <video class="image" src="/assets/video/Yaowarat-Set2.mp4" loop="1" autoplay="1" muted="1" playsinline="" poster="/assets/video/poster/Yaowarat-Set2.webp"></video>
                            <video class="image" src="/assets/video/Yaowarat-Set3.mp4" loop="1" autoplay="1" muted="1" playsinline="" poster="/assets/video/poster/Yaowarat-Set3.webp"></video>
                            <video class="image" src="/assets/video/Yaowarat-Set4.mp4" loop="1" autoplay="1" muted="1" playsinline="" poster="/assets/video/poster/Yaowarat-Set4.webp"></video>
                            <video class="image" src="/assets/video/Yaowarat-Set5.mp4" loop="1" autoplay="1" muted="1" playsinline="" poster="/assets/video/poster/Yaowarat-Set5.webp"></video>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="product-menu">
                        <div className="section-title mt--30 ptb--30">
                            <h1>สินค้า/บริการ</h1>
                        </div>

                        <div className="row">
                            {ProductList.map((value, index) => (
                                <div className="block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" key={index}>
                                    <div className="im_product-menu">
                                        <div className="thumbnail_inner">
                                            <div className="thumbnail">
                                                <Link to={value.link}>
                                                    {value.image}
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="content">
                                            <div className="inner">
                                                <Link className="transparent_link" to={value.link}></Link>
                                                <div className="product_heading">
                                                    <h4 className="title">{value.title}<br /></h4>
                                                    <h4 className="description">{value.titleTwo}</h4>
                                                </div>
                                                <div className="product_btn text-center">
                                                    <a href={value.link} class="btn-white btn-hover-primary">{value.titleBtn}</a>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>



                <div className="mt--40 mb--10 bg_color--1">
                    <div className="container">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 mt--10">
                                    <a href="https://www.facebook.com/yaowarat1yasothon" target="_blank" rel="noopener noreferrer"><img className="w-100" rel="noopener noreferrer" src="/assets/images/contact/fb-contact-1.webp" alt="ห้างทองเยาวราช1 ยโสธร1" /></a>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 mt--10">
                                    <a href="https://bit.ly/2XBIm9d" target="_blank" rel="noopener noreferrer"><img className="w-100" rel="noopener noreferrer" src="/assets/images/contact/fb-contact-2.webp" alt="ห้างทองเยาวราช1 ยโสธร สาขา2" /></a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div >

                <div className="sale-bg ptb--180 mt--80">
                    <div class="container">
                        <h1>ห้างทองเยาวราช1 ยโสธร </h1>
                        <p>ทองคำเนื้อดี คุณภาพมาตรฐานตาม สคบ จากเยาวราชกรุงเทพ <br />ลวดลายสวยประณีต โดดเด่น ทันสมัย ไม่ซ้ำใคร</p>
                        <a target="_blank" rel="noopener noreferrer" href="https://bit.ly/2XBIm9d" class="btn-default btn-hover-white">สอบถามเพิ่มเติม</a>
                    </div>
                </div>


                {/* Product List Menu */}

                <div className="product-area">
                    <div className="product-menu-wrapper">
                        <div className="container">
                            <div className="section-title mt--30 ptb--30">
                                <h1>ทองรูปพรรณ</h1>
                            </div>

                            <div className="portfolio-sacousel-inner mb--55">
                                <ProductMenu />
                            </div>

                        </div>
                    </div>
                </div>
                {/* END Product List Menu */}

                {/* Start About Area */}
                <div className="about-area ptb--50 bg_color--1">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--20 align-items-center">
                                <div className="col-lg-6 col-md-12">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/home/branch-2.webp" alt="ประวัติห้างทองเยาวราช1 ยโสธร" />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="about-inner inner">
                                        <div className="header-left d-flex align-items-center">
                                            <div className="logo">
                                                <img src="/assets/images/logo/logo.webp" alt="ห้างทองเยาวราช1 ยโสธร" />
                                            </div>
                                        </div>
                                        <div className="section-title mt--20">
                                            {/* <h2 className="title">ห้างทองเยาวราช1 ยโสธร</h2> */}
                                            <p className="description">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;กว่า 70 ปี ที่ทำธุรกิจร้านทอง จากรุ่นแรกสู่รุ่นที่ 3 เราได้ยึดหลักการความซื่อสัตย์ สุจริต การบริการลูกค้าทุกคนด้วยความจริงใจ มีความอ่อนน้อมถ่อมตน รับฟังความคิดเห็นลูกค้า และมีการปรับปรุงและพัฒนาตนเองอยู่เสมอ เราจะเน้นการทองรูปพรรณและทองคำแท่งเป็นหลัก ซึ่งจุดแข็งที่ทำให้เราประสบความสำเร็จอย่างยาวนาน นอกจากการบริการดูแลลูกค้าเป็นอย่างดีแล้ว เรามุ่งเน้นลวดลายทองคำที่สวยงาม ทันสมัย ให้เข้ากับรสนิยมการบริโภคของลูกค้าซึ่งเปลี่ยนไปแต่ละกาลเวลา เราเป็นธุรกิจครอบครัวที่ช่วยกันบริหารงานทุกสาขาด้วยความสามัคคีเป็นน้ำหนึ่งน้ำใจเดียวกัน เรายังมีมาตรการ ดูแลพนักงานทุกสาขา เสมือนเป็นคนในครอบครัว เราจะฝึกอบรมพนักงานทุกรุ่น ให้มุ่งเน้นการบริการให้ลูกค้าประทับใจ ลูกค้าสามารถเชื่อมั่นได้ว่า ไม่ว่าจะทำธุรกรรมใดๆกับเรา ลูกค้าจะได้รับความพึงพอใจอย่างที่สุด</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <a href="/goldsaver"><img className="w-100" src="/assets/images/goldsaver/goldsaver-3.webp" alt="จำหน่ายทองรูปพรรณ" /></a>

                </div>

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />
            </Fragment >
        )
    }
}
export default Startup;